import { useSelector } from "react-redux";
import "./AllEntityCatg.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomButton, CustomLoadingButton } from "../../../components/ui/CustomButton";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import Select from "react-select";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch";
import { Segmented } from 'antd';

const AllEntityCatg = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [categoryData, setCategoryData] = useState([]);

  const [isProcessing, setIsProcessing] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [currentAction, setCurrentAction] = useState("");
  const showBack = location.state?.showBack || "N";

  const [requiredDocuments, setRequiredDocuments] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);


  const [aentLayouts, setAentLayouts] = useState([]);
  const [definedLayouts, setDefinedLayouts] = useState([]);
  const [selectedLayout, setSelectedLayout] = useState(null);

  const [definedEntityTypes, setDefinedEntityTypes] = useState([]);
  const [selectedEntityType, setSelectedEntityType] = useState(null);


  const [alignValue, setAlignValue] = useState('requiredDocs');

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    file_path: "",
  });
  const [isCodeDialogOpened, setIsCodeDialogOpened] = useState(false);
  const [selectedCatg, setSelectedCatg] = useState({});
  const [newCode, setNewCode] = useState(null);
  const [newName, setNewName] = useState(null);
  const [kycCheckDays, setKycCheckDays] = useState(0);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");


  const fetchEntityCatg = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.get("/allEntityCatg/findAll");
      setCategoryData(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDocumentTypes = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "File Flag" }
      );
      const options = res.data?.map((code) => ({
        value: code?.sys_code,
        label: code?.sys_name,
      }));
      setDocumentTypes(options);
    } catch (error) {
      console.error("Error fetching file flags :", error);
    }
  };

  const fetchEntityLayouts = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Entity Layouts" }
      );
      const options = res.data?.map((code) => ({
        value: code?.sys_code,
        label: code?.sys_name,
      }));

      setDefinedLayouts(options);
    } catch (error) {
      console.error("Error fetching file flags :", error);
    }
  };
  const fetchEntityType = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll",
        {
          sys_org_code: currentUser.usr_org_code,
          sys_type: "Entity Types",
        }
      );

      const options = res.data?.map((entityType) => ({
        value: entityType?.sys_code,
        label: entityType?.sys_name,
      }));

      setDefinedEntityTypes(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const updateMandatoryFlag = (categoryId, documentType, mandatoryValue) => {
    const category = categoryData.find(item => item._id === categoryId);

    if (!category) {
      console.warn("Category not found");
      return;
    }

    const document = category.aent_required_docs.find(
      doc => doc.document_type === documentType
    );

    if (!document) {
      console.warn("Document type not found in category");
      return;
    }

    document.mandatory = mandatoryValue;
  }

  const handleRequiredDocs = (value, id, field) => {
    try {
      const newData = [...requiredDocuments];
      const index = newData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        newData[index][field] = value;
        setRequiredDocuments(newData);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleLayouts = (value, id, field) => {
    try {
      const newData = [...aentLayouts];
      const index = newData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        newData[index][field] = value;
        setAentLayouts(newData);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteCatg") {
        setIsConfirmDialogOpen(false);
        setIsProcessing(true);
        const res = await newRequest.delete(`/allEntityCatg/del/${objectToAction.object_id}`);
        // console.log(`/allEntityCatg/del ${JSON.stringify(res.data, null, 2)}`);
        if (res.data === "Document Deleted") {
          const filteredArray = categoryData.filter(
            (obj) => obj._id !== objectToAction.object_id
          );
          setCategoryData(filteredArray);
        } else {
          console.log("showing...");
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(res.data);
          setIsNotifyDialogOpen(true);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
      // Close the dialog
      setIsConfirmDialogOpen(false);
    }
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };

  const handleCatgAction = async () => {
    try {
      if (!newCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!newName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsProcessing(true);
      if (currentAction === "add") {
        const res = await newRequest.post(
          "/allEntityCatg/add",
          {
            aent_code: newCode,
            aent_name: newName,
            aent_required_docs: [],
            aent_kyc_check_freq: kycCheckDays || 0,
          }
        );
        setCategoryData((prevParams) => [...prevParams, { ...res.data }]);
        showToast("Category Added!", "success");
        setIsProcessing(false);
      } else {
        const updatedDoc = {
          aent_code: newCode,
          aent_name: newName,
          aent_required_docs: requiredDocuments || [],
          aent_kyc_check_freq: kycCheckDays || 0,
        };
        const res = await newRequest.put(
          `/allEntityCatg/upd/${selectedCatg._id}`, updatedDoc);
        setCategoryData((prev) => {
          return prev.map((param) =>
            param.aent_code === updatedDoc.aent_code ? updatedDoc : param
          );
        });
        showToast("Category Updated!", "success");
        setIsProcessing(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setNewCode(null);
      setNewName(null);
      setKycCheckDays(0);
      setIsCodeDialogOpened(false);
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetchEntityCatg();
    fetchDocumentTypes();
    fetchEntityLayouts();
    fetchEntityType();
  }, []);

  useEffect(() => {
    const filteredResults = categoryData?.filter(
      (item) =>
        item?.aent_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.aent_name?.toLowerCase().includes(searchTerm?.toLowerCase())
    );
    setFilteredData(filteredResults);
  }, [categoryData, searchTerm]);

  return (
    <motion.div
      className="all-entity-catg-list"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <div className="navbar">
        <div className="navbar-left">
          <div className="homeSearch">
            <FiSearch className="homeSearchIcon" />
            <input
              className="homeSearchInput"
              type="text"
              placeholder={t('search')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm?.length > 0 && (
              <MdClose
                onClick={() => setSearchTerm("")}
                className="homeSearchClear"
              />
            )}
          </div>
          {searchTerm?.length > 0 && <p className="sub-title">{`Records Found ${filteredData?.length}`}</p>}
        </div>
        <div className="navbar-right">
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#0f766e5d"
            endIcon={<RefreshIcon />}
            onClick={fetchEntityCatg}>
            {t('refresh')}
          </CustomLoadingButton>
          <CustomLoadingButton
            endIcon={<AddIcon />}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#0ea5a4"
            tooltip={"Add new category"}
            currentTheme={currentTheme}
            onClick={() => {
              try {
                setNewCode(null);
                setNewName(null);
                setKycCheckDays(0);
                setIsCodeDialogOpened(true);
                setCurrentAction("add");
              } catch (error) {
                console.log(error);
              }
            }}
          >
            {t('newCategory')}
          </CustomLoadingButton>
          {/* This part shows if the menu was opened from home screen */}
          {showBack === "Y" && <hr className="separator-v" />}
          {showBack === "Y" &&
            <span className="back-icon" onClick={() => navigate(-1)}>
              <MdArrowBackIos size={24} />
            </span>}
        </div>
      </div>
      <div className="entity-catg-content">
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
              width: "100%",
              height: "100%",
            }}
          >
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        ) : (
          <div className="all-entity-catg-wrapper">
            {filteredData?.map((catg) => (
              <div
                className="single-catg"
                key={catg?._id}
                onClick={(e) => {
                  try {
                    // console.log(`catg  ${JSON.stringify(catg, null, 2)}`);
                    setSelectedCatg(catg);
                    setNewCode(catg?.aent_code);
                    setNewName(catg?.aent_name);
                    setKycCheckDays(catg?.aent_kyc_check_freq || 0);
                    setRequiredDocuments([]);
                    setRequiredDocuments(catg?.aent_required_docs);

                    setAentLayouts([]);
                    setAentLayouts(catg?.aent_layouts);

                    setIsCodeDialogOpened(true);
                    setCurrentAction("edit");
                    setAlignValue("requiredDocs");
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                <div className="single-catg-title">
                  <h2 className="catg-name">{catg?.aent_name}</h2>
                </div>
                <div className="catg-code">
                  <span className="sub-title">{catg?.aent_code}</span>

                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={(e) => {
                      try {
                        e.stopPropagation();
                        let action_text = `Delete ${catg?.aent_name}?`;
                        setObjectToAction({
                          object_id: catg?._id,
                          action_text: action_text,
                          file_path: "",
                        });
                        setConfirmDialogAction("deleteCatg");
                        setIsConfirmDialogOpen(true);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    color="#E53935"
                    icon={<MdDelete />}
                    width={"35px"}
                    height={"35px"} />
                </div>
                <div className="user-wrapper">
                  <WorkedOnBy name={catg?.updated_by_name_xx} photoUrl={catg?.updated_by_photo_url_xx} time_ago_xx={catg?.time_ago_xx} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {isCodeDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
        >
          <div className="overlay-wrapper" style={{ width: "700px" }}>
            <div className="overlay-navbar">
              <h1 className="main-title">{t('category')}</h1>
              <CircularButton currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setNewCode(null);
                    setNewName(null);
                    setKycCheckDays(0);
                    setIsCodeDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                icon={<MdClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="overlay-content">
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <div className="input-item-with-label">
                  <label
                    htmlFor="newName"
                    className="form-dropdown-label"
                    style={{ width: "90px" }}
                  >
                    {t('name').toUpperCase()}
                  </label>
                  <input
                    id="newName"
                    name="newName"
                    type="text"
                    placeholder={t('name').toUpperCase()}
                    value={newName}
                    className="form-input-item"
                    style={{ width: "300px" }}
                    onChange={(e) => setNewName(e.target.value)}
                  />
                </div>
                <div className="input-item-with-label">
                  <label
                    htmlFor="newCode"
                    className="form-dropdown-label"
                    style={{ width: "100px" }}
                  >
                    {t('code').toUpperCase()}
                  </label>
                  <input
                    id="newCode"
                    name="newCode"
                    type="text"
                    placeholder={t('code').toUpperCase()}
                    value={newCode}
                    disabled={currentAction === "edit"}
                    className="form-input-item"
                    style={{ width: "150px" }}
                    onChange={(e) => setNewCode(e.target.value)}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="kycCheckDays"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('kycFreq').toUpperCase()}
                </label>
                <input
                  id="kycCheckDays"
                  name="kycCheckDays"
                  type="number"
                  placeholder={t('code').toUpperCase()}
                  value={kycCheckDays}
                  className="form-input-item"
                  style={{ width: "150px", textAlign: "right" }}
                  onChange={(e) => setKycCheckDays(e.target.value)}
                />
                <label
                  htmlFor="kycCheckDays"
                  className="form-dropdown-label"
                  style={{ width: "max-content" }}
                >
                  {t('kycCheck').toUpperCase()}
                </label>
              </div>
              <Segmented
                defaultValue="requiredDocs"
                style={{
                  margin: "8px 5px",
                  height: '40px',
                }}
                className="custom-segmented"
                onChange={(value) => setAlignValue(value)}
                options={[
                  { label: <span style={{ fontSize: "15px" }}>{t('requiredDocuments').toUpperCase()}</span>, value: 'requiredDocs' },
                  { label: <span style={{ fontSize: "15px" }}>{t('layouts').toUpperCase()}</span>, value: 'layouts' },
                ]}
              />
              <hr className="separator-h" style={{ margin: "3px 0px" }} />
              {alignValue === "requiredDocs" &&
                <div className="available-services">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "450px" }}>
                              <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                <Select
                                  id="docType"
                                  name="docType"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="150px"
                                  value={selectedDocumentType}
                                  onChange={(selectedOption) => setSelectedDocumentType(selectedOption)}
                                  options={documentTypes}
                                  isSearchable={true}
                                  placeholder={t('document')}
                                />
                                <Select
                                  id="document_entity_type"
                                  name="document_entity_type"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="100%"
                                  value={selectedEntityType}
                                  onChange={(selectedOption) => setSelectedEntityType(selectedOption)}
                                  options={definedEntityTypes}
                                  isSearchable={true}
                                  placeholder={t('type')}
                                />
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {

                                      if (!selectedDocumentType?.value) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select document type!`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }

                                      if (!selectedEntityType?.value) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select entity type!`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }


                                      const res = await newRequest.post("/allEntityCatg/addDocument",
                                        {
                                          catg_docid: selectedCatg?._id,
                                          document_type: selectedDocumentType?.value,
                                          document_entity_type: selectedEntityType?.value,
                                          mandatory: "Y",
                                          document_remarks: selectedDocumentType?.label,
                                        });

                                      // console.log(`allEntityCatg ${JSON.stringify(res.data, null, 2)}`);

                                      if (res.data?.msg === "added") {
                                        setRequiredDocuments((prevParams) => [...prevParams, { ...res.data?.doc }]);
                                        setSelectedDocumentType(null);
                                        setSelectedEntityType(null);
                                        showToast("Added!", "success");
                                      } else if (res.data?.msg === "exists") {
                                        showToast(`${selectedDocumentType?.label} is already added to this type`, "warning");
                                      } else {
                                        showToast("Error adding asset class!", "error");
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd color="green" />}
                                  width={"35px"}
                                  height={"35px"} />
                              </div>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }} >
                              <span>{`${t('required').toUpperCase()}`}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{`${t('action').toUpperCase()}`}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {requiredDocuments?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedDocumentType?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedDocumentType(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "450px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1px", width: "100%" }}>
                                  <span className="sub-title">{row?.document_type_xx}</span>
                                  <span className="sub-title xrsmall soft">{t('document')}</span>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1px", width: "100%" }}>
                                  <span className="sub-title">{row?.document_entity_type}</span>
                                  <span className="sub-title xrsmall soft">{t('category')}</span>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <ToggleSwitch
                                  value={row?.mandatory}
                                  onChange={(newValue) => {
                                    try {
                                      handleRequiredDocs(newValue, row?._id, "mandatory");
                                      // update main array as well
                                      updateMandatoryFlag(selectedCatg._id, row?.document_type, newValue);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  label={""}
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                  disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                />
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async (e) => {
                                      try {
                                        const res = await newRequest.post("/allEntityCatg/removeDocument",
                                          {
                                            catg_docid: selectedCatg?._id,
                                            document_type: row?.document_type,
                                            document_entity_type: row?.document_entity_type,
                                          });

                                        if (res.data?.msg === "removed") {
                                          setRequiredDocuments((prevData) => prevData.filter(doc => doc?.document_type !== row?.document_type && doc?.document_entity_type !== row?.document_entity_type));
                                          setSelectedCatg((prevData) => ({
                                            ...prevData,
                                            aent_required_docs: prevData.aent_required_docs.filter(
                                              (doc) => doc?.document_type !== row?.document_type &&
                                                doc?.document_entity_type !== row?.document_entity_type
                                            ),
                                          }));
                                          showToast("Removed!", "success");
                                        } else {
                                          showToast("Error deleting report!", "error");
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"35px"}
                                    height={"35px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>}
              {alignValue === "layouts" &&
                <div className="available-services">
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableHead className="tablehead">
                          <TableRow className="tablerow">
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              #
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "650px" }}>
                              <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                <Select
                                  id="layout_type"
                                  name="layout_type"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="150px"
                                  value={selectedLayout}
                                  onChange={(selectedOption) => setSelectedLayout(selectedOption)}
                                  options={definedLayouts}
                                  isSearchable={true}
                                  placeholder={t('layouts')}
                                />
                                <Select
                                  id="entity_type"
                                  name="entity_type"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="100%"
                                  value={selectedEntityType}
                                  onChange={(selectedOption) => setSelectedEntityType(selectedOption)}
                                  options={definedEntityTypes}
                                  isSearchable={true}
                                  placeholder={t('type')}
                                />
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {
                                      if (!selectedLayout) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select layout!`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }

                                      if (!selectedEntityType) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select entity type!`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }

                                      const res = await newRequest.post("/allEntityCatg/addLayout",
                                        {
                                          catg_docid: selectedCatg?._id,
                                          layout_key: selectedLayout?.value,
                                          layout_entity_type: selectedEntityType?.value,
                                          layout_title: selectedLayout?.label,
                                        });

                                      if (res.data?.msg === "added") {
                                        setAentLayouts((prevParams) => [...prevParams, { ...res.data?.doc }]);
                                        setSelectedLayout(null);
                                        setSelectedEntityType(null);
                                        showToast("Added!", "success");
                                      } else if (res.data?.msg === "exists") {
                                        showToast(`${selectedLayout?.label} is already added to this type`, "warning");
                                      } else {
                                        showToast("Error adding layout!", "error");
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                              </div>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }} >
                              <span>{`${t('key').toUpperCase()}`}</span>
                            </TableCell>
                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <span>{`${t('action').toUpperCase()}`}</span>
                              </TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody className="tablebody">
                          {aentLayouts?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className={`${selectedLayout?._id === row?._id ? "tablerow current" : "tablerow"}`}
                              onClick={() => setSelectedLayout(row)}
                            >
                              <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                {index + 1}
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "450px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1px", width: "100%" }}>
                                  <span className="sub-title">{row?.layout_name_xx}</span>
                                  <span className="sub-title xrsmall soft">{t('layout')}</span>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell left" style={{ maxWidth: "200px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1px", width: "100%" }}>
                                  <span className="sub-title">{row?.layout_entity_type}</span>
                                  <span className="sub-title xrsmall soft">{t('category')}</span>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1px", width: "100%" }}>
                                  <span className="sub-title">{row?.layout_key}</span>
                                  <span className="sub-title xrsmall soft">{t('key')}</span>
                                </div>
                              </TableCell>
                              {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async (e) => {
                                      try {
                                        const res = await newRequest.post("/allEntityCatg/removeLayout",
                                          {
                                            catg_docid: selectedCatg?._id,
                                            layout_key: row?.layout_key,
                                            layout_entity_type: row?.layout_entity_type,
                                          });

                                        if (res.data?.msg === "removed") {
                                          setAentLayouts((prevData) => prevData.filter(doc => doc?.layout_key !== row?.layout_key && doc?.layout_entity_type !== row?.layout_entity_type));
                                          setSelectedCatg((prevData) => ({
                                            ...prevData,
                                            aent_layouts: prevData.aent_layouts.filter(
                                              (doc) => doc?.layout_key !== row?.layout_key &&
                                                doc?.layout_entity_type !== row?.layout_entity_type
                                            ),
                                          }));
                                          setSelectedLayout(null);
                                          showToast(t('removed'), "success");
                                        } else {
                                          showToast("Error deleting report!", "error");
                                        }
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    color="#E53935"
                                    icon={<MdDelete />}
                                    width={"35px"}
                                    height={"35px"} />
                                </TableCell>}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              }
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                borderRadiusType="both"
                variant="tint"
                color="#00D37F"
                tooltip="Save changes"
                currentTheme={currentTheme}
                onClick={handleCatgAction}>
                {currentAction === "edit" ? t('save').toUpperCase() : t('add').toUpperCase()}
              </CustomLoadingButton >
            </div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default AllEntityCatg;
